import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const Icon = styled.div`
  display: flex;
`;

export const Button = styled.button`
  cursor: pointer;
  background-color: transparent;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    cursor: text;
    color: ${({ theme }) => theme.neutral_700};

    &:hover {
      text-decoration: none;
    }
  }
`;
